import { connect } from "react-redux";
import withLayout from "../components/withLayout";
import * as actionsMisc from "../../../_actions/misc";
import * as actionsDimension from "../../../_actions/dimension";

const mapStateToProps = ({ Dimension, Misc, Ticket }) => ({
    language: Misc.Settings.language,
    languageList: Dimension.Language.languageList,
    languageListLoading: Dimension.Language.fetching.loading,
    ticketUpdating: Ticket.updating.loading
});

const mapDispatchToProps = dispatch => ({
    getLanguageList: () => {
        dispatch(actionsDimension.getLanguageList());
    },
    setLanguage: language => {
        dispatch(actionsMisc.setLanguage(language));
    },
    resetLanguage: () => {
        dispatch(actionsMisc.resetLanguage());
    }
});

export default (WrappedComponent, MenuComponent = null) => connect(mapStateToProps, mapDispatchToProps)(withLayout(WrappedComponent, (MenuComponent = null)));
